import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import logo from '../../assets/logo.png';
import './Navbar.css';

export default function Navbar() {
  const { user, logout, isAdmin, isAboutu } = useAuth();
  const navigate  = useNavigate();
  const location  = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  const handleLogout = () => { logout(); navigate('/login'); };
  const isActive = (path) => location.pathname.startsWith(path);

  if (!user) return null;

  return (
    <nav className="navbar">
      <div className="navbar-inner">
        <Link to="/" className="navbar-brand">
          <img src={logo} alt="DADU Logo" className="brand-logo" />
          <span className="brand-text">Feedback</span>
        </Link>

        <div className={`navbar-links ${menuOpen ? 'open' : ''}`}>

          {/* Regular user — only feedback link */}
          {!isAdmin && !isAboutu && (
            <Link
              to="/feedback"
              className={`nav-link ${isActive('/feedback') ? 'active' : ''}`}
              onClick={() => setMenuOpen(false)}
            >
              Submit Feedback
            </Link>
          )}

          {/* Admin — full navigation */}
          {isAdmin && (
            <>
              <Link to="/admin/dashboard"        className={`nav-link ${isActive('/admin/dashboard') ? 'active' : ''}`}        onClick={() => setMenuOpen(false)}>Dashboard</Link>
              <Link to="/admin/authorized-users" className={`nav-link ${isActive('/admin/authorized-users') ? 'active' : ''}`} onClick={() => setMenuOpen(false)}>Users</Link>
              <Link to="/admin/departments"      className={`nav-link ${isActive('/admin/departments') ? 'active' : ''}`}      onClick={() => setMenuOpen(false)}>Departments</Link>
              <Link to="/admin/audit"            className={`nav-link ${isActive('/admin/audit') ? 'active' : ''}`}            onClick={() => setMenuOpen(false)}>Audit Logs</Link>
            </>
          )}

          {/* aboutu — dashboard only, no other links */}
          {isAboutu && (
            <Link
              to="/admin/dashboard"
              className={`nav-link ${isActive('/admin/dashboard') ? 'active' : ''}`}
              onClick={() => setMenuOpen(false)}
            >
              Dashboard
            </Link>
          )}

        </div>

        <div className="navbar-user">
          {user.avatar && (
            <img src={user.avatar} alt={user.name} className="user-avatar" referrerPolicy="no-referrer" />
          )}
          <div className="user-info hide-mobile">
            <span className="user-name">{user.name}</span>
            <span className={`badge ${
              user.role === 'admin_editor' ? 'badge-accent'   :
              user.role === 'admin_viewer' ? 'badge-sky'      :
              user.role === 'aboutu'       ? 'badge-primary'  : 'badge-primary'
            }`}>
              {user.role === 'admin_editor' ? 'Editor'     :
               user.role === 'admin_viewer' ? 'Viewer'     :
               user.role === 'aboutu'       ? 'Dept View'  : 'User'}
            </span>
          </div>
          <button className="btn btn-ghost btn-sm" onClick={handleLogout}>Sign out</button>
          <button className={`hamburger ${menuOpen ? 'open' : ''}`} onClick={() => setMenuOpen(!menuOpen)} aria-label="Toggle menu">
            <span /><span /><span />
          </button>
        </div>
      </div>
    </nav>
  );
}
